import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { initializeIcons } from "@fluentui/react";
import { App as ANTDApp } from 'antd';

import NewLayout from "./pages/layout/NewLayout";
import LoginLayout from "./pages/login/login";
import { AppStateProvider } from "./state/AppProvider";
import RouteAuthorisation from "./components/authentication/RouteAuthorisation";
import { UserRole } from "./constants/enums";
import AdminHome from "./pages/admin/AdminHome";
initializeIcons();

export default function App() {

    return (
        <ANTDApp>
            <BrowserRouter>
                <Routes>
                    <Route path="/login" element={<LoginLayout />} />
                    <Route path="/logout" element={<LoginLayout />} />
                    <Route path="/admin" element={<RouteAuthorisation allowedRoles={[UserRole.Admin]} ><AppStateProvider><AdminHome /></AppStateProvider></RouteAuthorisation>} />
                    <Route path="/" element={<RouteAuthorisation allowedRoles={[UserRole.User, UserRole.Admin, UserRole.NhgUser, UserRole.LtaUser, UserRole.SsoeUser]}> <AppStateProvider><NewLayout /></AppStateProvider></RouteAuthorisation>} />
                    <Route path="*" element={<Navigate to="/" />} />
                </Routes>
            </BrowserRouter>
        </ANTDApp>
    );
}

createRoot(document.getElementById("root") as HTMLElement).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
